import { Component } from '@verndale/core';
import cookie from 'cookie-cutter';

class ConfirmationModal extends Component {
  setupDefaults() {
    this.dom = {
      dialog: this.el,
      closeButton: this.el.querySelector('.confirmation-modal__close'),
      completeButton: this.el.querySelector('.btn'),
      form: this.el.querySelector('.confirmation-modal__form'),
      checkboxes: Array.from(
        this.el.querySelectorAll('input[type="checkbox"]')
      ),
      formNameField: this.el.querySelector('input[name="form_name"]')
    };

    // Store scroll position for modal
    this.scrollPosition = 0;

    // Create global function to trigger the modal
    this.setupGlobalTrigger();
  }

  setupGlobalTrigger() {
    // Create the global footerModal function that dispatches the custom event
    window.footerModal = () => {
      window.dispatchEvent(new CustomEvent('footerModal'));
    };
  }

  addListeners() {
    if (this.dom.closeButton) {
      this.dom.closeButton.addEventListener(
        'click',
        this.handleClose.bind(this)
      );
    }

    if (this.dom.completeButton) {
      this.dom.completeButton.addEventListener(
        'click',
        this.handleComplete.bind(this)
      );
    }

    document.addEventListener('keydown', this.handleKeydown.bind(this));
    window.addEventListener('footerModal', this.open.bind(this));
  }

  removeListeners() {
    if (this.dom.closeButton) {
      this.dom.closeButton.removeEventListener(
        'click',
        this.handleClose.bind(this)
      );
    }
    if (this.dom.completeButton) {
      this.dom.completeButton.removeEventListener(
        'click',
        this.handleComplete.bind(this)
      );
    }
    document.removeEventListener('keydown', this.handleKeydown.bind(this));
  }

  handleKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  handleClose() {
    this.close();
  }

  handleComplete() {
    const selected = this.getSelectedValues();
    const brazeData = this.getBrazeDataFromCookie();

    // Send to Braze via dataLayer push
    this.sendToBraze(selected, brazeData);

    const event = new CustomEvent('confirmation:complete', {
      bubbles: true,
      detail: { selected }
    });

    this.el.dispatchEvent(event);
    this.close();
  }

  getSelectedValues() {
    const selected = [];
    this.dom.checkboxes.forEach(checkbox => {
      if (checkbox.checked) {
        selected.push(checkbox.value);
      }
    });
    return selected;
  }

  getBrazeDataFromCookie() {
    try {
      const brazeCookieValue = cookie.get('BrazeCookie');
      if (brazeCookieValue) {
        const decodedValue = atob(brazeCookieValue);
        return JSON.parse(decodedValue);
      }
    } catch (error) {
      console.warn('Error reading BrazeCookie:', error);
    }
    return null;
  }

  sendToBraze(selectedGroups, brazeData) {
    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];

    // Get form name from hidden field or use default
    const formName = this.dom.formNameField
      ? this.dom.formNameField.value
      : 'Additional Email Opt In';

    // Prepare the data layer push
    const dataLayerEvent = {
      event: this.el.dataset.event,
      email: brazeData?.['Braze.Form.Email'] || '',
      fname: brazeData?.['Braze.Form.FirstName'] || '',
      lname: brazeData?.['Braze.Form.LastName'] || '',
      groups: selectedGroups.join(','),
      source: document.title,
      form_name: formName
    };

    // Push to dataLayer
    window.dataLayer.push(dataLayerEvent);
  }

  open() {
    // Save current scroll position
    this.scrollPosition =
      window.pageYOffset || document.documentElement.scrollTop;

    // Save original scroll behavior
    this.originalScrollBehavior = document.documentElement.style.scrollBehavior;

    // Lock the body position at the current scroll position
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.scrollPosition}px`;
    document.body.style.width = '100%';

    if (typeof this.dom.dialog.showModal === 'function') {
      try {
        this.dom.dialog.showModal();
      } catch (e) {
        this.dom.dialog.setAttribute('open', 'open');
      }
    } else {
      this.dom.dialog.setAttribute('open', 'open');
    }
  }

  close() {
    if (typeof this.dom.dialog.close === 'function') {
      try {
        this.dom.dialog.close();
      } catch (e) {
        this.dom.dialog.removeAttribute('open');
      }
    } else {
      this.dom.dialog.removeAttribute('open');
    }

    // Restore body styles and scroll position seamlessly
    const scrollY = this.scrollPosition;

    // Temporarily disable smooth scrolling to prevent visible scroll animation
    document.documentElement.style.scrollBehavior = 'auto';

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    // Restore scroll immediately without animation
    window.scrollTo(0, scrollY);

    // Restore original scroll behavior
    document.documentElement.style.scrollBehavior =
      this.originalScrollBehavior || '';
  }
}

export default ConfirmationModal;
